import React, { useState } from 'react';

const fmt = (v, n = 4) => (v == null || isNaN(v)) ? '—' : Number(v).toFixed(n);

const numColor = (v) =>
  v == null || isNaN(v) ? 'text-gray-400'
  : v > 0 ? 'text-emerald-600 dark:text-emerald-400'
  : v < 0 ? 'text-red-500 dark:text-red-400' : 'text-gray-400';

const FeatureWeightsTable = ({ features }) => {
  const [sortBy, setSortBy] = useState('votes');
  const [asc, setAsc] = useState(false);

  if (!features?.length) {
    return <div className="text-sm text-gray-400 py-4 text-center">No surviving features.</div>;
  }

  const sorted = [...features].sort((a, b) => {
    const av = a[sortBy] ?? 0;
    const bv = b[sortBy] ?? 0;
    return asc ? (Math.abs(av) - Math.abs(bv)) : (Math.abs(bv) - Math.abs(av));
  });

  const handleSort = (col) => {
    if (sortBy === col) setAsc(!asc);
    else { setSortBy(col); setAsc(false); }
  };

  const Header = ({ col, label, align = 'right' }) => (
    <th
      onClick={() => handleSort(col)}
      className={`px-2 py-2 text-${align} text-xs uppercase tracking-wider cursor-pointer select-none ${
        sortBy === col ? 'text-brand-gold' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700'
      }`}
    >
      {label}{sortBy === col ? (asc ? ' ↑' : ' ↓') : ''}
    </th>
  );

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 dark:bg-gray-800/50">
          <tr>
            <Header col="feature" label="Feature" align="left" />
            <Header col="votes" label="Votes" />
            <Header col="ic_icir" label="ICIR" />
            <Header col="ic_mean" label="Mean IC" />
            <Header col="en_coef" label="EN coef" />
            <Header col="rf_imp" label="RF imp" />
            <Header col="rf_tstat" label="RF t-stat" />
          </tr>
        </thead>
        <tbody>
          {sorted.map(f => (
            <tr key={f.feature} className="hover:bg-gray-50 dark:hover:bg-gray-800/50 border-t border-gray-100 dark:border-gray-800/50">
              <td className="px-2 py-1.5 font-mono text-xs">{f.feature}</td>
              <td className="px-2 py-1.5 text-right">
                <span className={`inline-block px-1.5 py-0.5 rounded text-[10px] uppercase tracking-wider ${
                  f.votes === 3 ? 'bg-brand-gold/20 text-brand-gold'
                  : 'bg-gray-100 dark:bg-gray-800 text-gray-500'
                }`}>
                  {f.votes}/3
                </span>
              </td>
              <td className={`px-2 py-1.5 text-right text-xs font-mono ${numColor(f.ic_icir)}`}>{fmt(f.ic_icir, 3)}</td>
              <td className={`px-2 py-1.5 text-right text-xs font-mono ${numColor(f.ic_mean)}`}>{fmt(f.ic_mean, 4)}</td>
              <td className={`px-2 py-1.5 text-right text-xs font-mono ${numColor(f.en_coef)}`}>{fmt(f.en_coef, 4)}</td>
              <td className="px-2 py-1.5 text-right text-xs font-mono text-gray-600 dark:text-gray-400">{fmt(f.rf_imp, 4)}</td>
              <td className="px-2 py-1.5 text-right text-xs font-mono text-gray-600 dark:text-gray-400">{fmt(f.rf_tstat, 2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FeatureWeightsTable;
